export class EnvironmentConfig {
  endPoint: string;
  appInsights: {
    instrumentationKey: string;
  };
}
